import { logAppHostMetrics } from '@office-start/app-host-component';
import { AppbarConnectorService } from '@office-start/appbar-connector-service';
import { copilotM365AppId } from '@office-start/m365-apps-service';
import React, { useEffect, useRef } from 'react';
export var HiddenIframeForMOSWarmup = function (_a) {
    var id = _a.id, src = _a.src;
    var iframeRef = useRef(null);
    var appbarConnectorService = AppbarConnectorService.getInstance();
    useEffect(function () {
        logAppHostMetrics({
            appId: copilotM365AppId,
            scenarioName: 'CopilotPreWarmStarted',
            clientTimeStamp: appbarConnectorService === null || appbarConnectorService === void 0 ? void 0 : appbarConnectorService.userClickTime,
            tileChanged: appbarConnectorService === null || appbarConnectorService === void 0 ? void 0 : appbarConnectorService.tileChanged,
            appUrl: window.location.pathname,
            appSearchParams: window.location.search,
            resourceDeliveryType: appbarConnectorService === null || appbarConnectorService === void 0 ? void 0 : appbarConnectorService.resourceDeliveryType,
        });
        // Only log the metrics once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        var timer = setTimeout(function () {
            if (iframeRef.current) {
                logAppHostMetrics({
                    appId: copilotM365AppId,
                    scenarioName: 'CopilotPreWarmCompleted',
                    clientTimeStamp: appbarConnectorService === null || appbarConnectorService === void 0 ? void 0 : appbarConnectorService.userClickTime,
                    tileChanged: appbarConnectorService === null || appbarConnectorService === void 0 ? void 0 : appbarConnectorService.tileChanged,
                    appUrl: window.location.pathname,
                    appSearchParams: window.location.search,
                    resourceDeliveryType: appbarConnectorService === null || appbarConnectorService === void 0 ? void 0 : appbarConnectorService.resourceDeliveryType,
                });
                iframeRef.current.remove();
            }
        }, 20000); // 20 seconds
        return function () { return clearTimeout(timer); };
    }, []);
    return (React.createElement("iframe", { ref: iframeRef, sandbox: undefined, id: id, src: src, width: "0", height: "0", style: { display: 'none', border: 'none' }, title: "Hidden Iframe" }));
};
//# sourceMappingURL=HiddenIframeForMOSWarmup.js.map